import { LOGOUT } from '../auth/AuthConstants'
import { errorCodes, getUserFriendlyErrorMessage } from '../../utils/errormessages'
import {
  ALLERGY_NAME_NOT_UNIQUE_ERROR,
  ALLERGY_NAME_NOT_VALID_ERROR,
  ALLERGY_NOT_FOUND_ERROR,
  ALLERGY_SEVERITY_NOT_VALID_ERROR,
  FORBIDDEN_ERROR,
  INTERNAL_SERVER_ERROR,
  THIRD_PARTY_ERROR,
  TREAT_COMMUNICATION_ERROR,
  VISIT_CALL_FORBIDDEN_ERROR,
  VISIT_NOT_FOUND_ERROR,
} from '../../utils/constants'
import {
  ADD_PATIENT_ALLERGY,
  ADD_PATIENT_ALLERGY_ERROR,
  ADD_PATIENT_ALLERGY_SUCCESS,
  BACK_IN_QUEUE,
  BACK_IN_QUEUE_ERROR,
  CHANGE_CURRENT_PATIENT_ACCOUNT_INFO,
  CHANGE_IS_VISIT_ENDED,
  CLEAR_PHONE_TOKEN,
  CLEAR_STALE_CALL_TOKENS,
  COMPLETE_VISIT_CALL,
  COMPLETE_VISIT_CALL_ERROR,
  COMPLETE_VISIT_CALL_SUCCESS,
  DELETE_PATIENT_ALLERGY,
  DELETE_PATIENT_ALLERGY_ERROR,
  DELETE_PATIENT_ALLERGY_SUCCESS,
  DELETE_VISIT_NOTES,
  DELETE_VISIT_NOTES_ERROR,
  DELETE_VISIT_NOTES_SUCCESS,
  DELETE_VISIT_PATIENT_INSTRUCTIONS,
  DELETE_VISIT_PATIENT_INSTRUCTIONS_ERROR,
  DELETE_VISIT_PATIENT_INSTRUCTIONS_SUCCESS,
  END_VISIT,
  END_VISIT_ERROR,
  END_VISIT_SUCCESS,
  GET_PATIENT_PRESCRIPTIONS,
  GET_PATIENT_PRESCRIPTIONS_ERROR,
  GET_PATIENT_PRESCRIPTIONS_SUCCESS,
  GET_PATIENT_TREAT_URL,
  GET_PATIENT_TREAT_URL_ERROR,
  GET_PATIENT_TREAT_URL_SUCCESS,
  GET_PATIENTS,
  GET_PATIENTS_BACKGROUND,
  GET_PATIENTS_ERROR,
  GET_PATIENTS_SUCCESS,
  GET_PHONE_CALL_TOKEN,
  GET_PHONE_CALL_TOKEN_ERROR,
  GET_PHONE_CALL_TOKEN_SUCCESS,
  GET_PROVIDER,
  GET_PROVIDER_ERROR,
  GET_PROVIDER_SUCCESS,
  GET_VISIT_INFO,
  GET_VISIT_INFO_ERROR,
  GET_VISIT_INFO_SUCCESS,
  GET_VISIT_PATIENT_CHART,
  GET_VISIT_PATIENT_CHART_ERROR,
  GET_VISIT_PATIENT_CHART_SUCCESS,
  LEAVE_VISIT_ROOM,
  RESET_IS_ADDED_ALLERGY_STATUS,
  RESET_IS_DELETED_ALLERGY_STATUS,
  RESET_WAITING_ROOM_PAGE,
  SAVE_VISIT_NOTES,
  SAVE_VISIT_NOTES_ERROR,
  SAVE_VISIT_NOTES_SUCCESS,
  SAVE_VISIT_PATIENT_INSTRUCTIONS,
  SAVE_VISIT_PATIENT_INSTRUCTIONS_ERROR,
  SAVE_VISIT_PATIENT_INSTRUCTIONS_SUCCESS,
  SEARCH_FOR_ICD_CODES,
  SEARCH_FOR_ICD_CODES_ERROR,
  SEARCH_FOR_ICD_CODES_SUCCESS,
  SET_ERROR,
  SET_ERROR_ALLERGY,
  SET_FORCE_UPDATE_WAITING_ROOM,
  SET_IS_PATIENT_INSTRUCTIONS_SAVED_SUCCESS,
  SET_IS_ROOM_SUCCESS_CREATED,
  SET_IS_VISIT_NOTES_SAVED_SUCCESS,
  SET_LOADING,
  SET_NEW_PROVIDER_PROFILE_SETTINGS,
  SET_PATIENT_TREAT_URL,
  SET_VISIT_INFO,
  SET_VISIT_PATIENT_HAS_ALLERGIES,
  SET_VISIT_PATIENT_HAS_ALLERGIES_ERROR,
  SET_VISIT_PATIENT_HAS_ALLERGIES_SUCCESS,
  SET_VISIT_PATIENT_HAS_NO_ALLERGIES,
  SET_VISIT_PATIENT_HAS_NO_ALLERGIES_ERROR,
  SET_VISIT_PATIENT_HAS_NO_ALLERGIES_SUCCESS,
  SET_VISIT_ROOM,
  START_VISIT_VIDEO_CALL,
  START_VISIT_VIDEO_CALL_ERROR,
  START_VISIT_VIDEO_CALL_SUCCESS,
  SUCCESS_VISIT,
  text,
  UPDATE_ICD_CODES,
  UPDATE_ICD_CODES_ERROR,
  UPDATE_ICD_CODES_SUCCESS,
  visitNotStarted,
  SET_PHONE_ERROR,
  CLEAR_PHONE_ERROR,
  orderData,
  ADD_VISIT_ORDER,
  SET_IS_VIDEO_DECLINED,
  SET_IS_REQUESTING_PERMISSIONS,
  SET_PERMISSIONS_GRANTED,
  SET_PERMISSIONS_DENIED,
  SET_IS_REQUESTING_ROOM_INFO,
  SET_PROVIDER_INITIATING_VISIT,
} from './WaitingRoomConstants'
import {
  ADD_PATIENT_ALLERGY_SUCCESS as ADD_PATIENT_ALLERGY_SUCCESS_CHARTS,
  DELETE_PATIENT_ALLERGY_FROM_STORAGE,
  DELETE_PATIENT_ALLERGY_SUCCESS as DELETE_PATIENT_ALLERGY_SUCCESS_CHARTS,
  GET_PATIENTS_CHART_SUCCESS,
  SET_PATIENT_HAS_ALLERGIES_SUCCESS,
  SET_PATIENT_HAS_NO_ALLERGIES_SUCCESS,
  UPDATE_ICD_CODES_SUCCESS as CHART_UPDATE_ICD_CODES_SUCCESS,
  CHECK_PHONE,
  CHECK_PHONE_SUCCESS,
  CHECK_PHONE_ERROR,
  GET_PATIENT_CREDIT_CARDS_SUCCESS,
} from '../charts/ChartsConstants'
import {
  EDIT_PROVIDER_PROFILE_IMAGE_SUCCESS,
  EDIT_PROVIDER_PROFILE_INFO_SUCCESS,
} from '../accountSettings/AccountSettingsConstants'
import { apiErrorCodes } from '../../utils/apiHelper'
import { GET_PATIENT_DRUG_SCREEN_INFO_SUCCESS } from '../file-pop-up/FilePopUpConstants'
import { appInsights } from '../../utils/appInsights'
import {
  START_INPERSON_VISIT,
  START_INPERSON_VISIT_SUCCESS,
  START_INPERSON_VISIT_ERROR,
} from '../visits/VisitsConstants'
import { client } from 'api/components/queryClient'
import { getGetProfileQueryKey } from 'api/generated/profile/profile'

const initialVisitRoomState = {
  videoCallTimeout: null,
  // Must live here, beside `videoCallTimeout`, so every reset path clears the two in lockstep.
  // If they ever desynchronise, the ring window is measured across two different call attempts
  // and is meaningless — do not add a bespoke clear for either one (QMD-4640).
  videoCallTimeoutReceivedAtMs: null,
  isVideoDeclined: false,
  isRoomSuccessCreated: false,
  videoCallToken: '',
  roomName: '',
  roomUrl: '',
  platform: '',
  activeVisitId: '',
  patientVideoCallName: '',
  visitCallId: '',
  phoneCallToken: '',
  visitVideoCallId: '',
}

const initialState = {
  loading: false,
  forceLoading: false,
  notesChangeLoading: false,
  isVisitEndedSuccess: false,
  error: '',
  profileImage: null,
  selectedVisitForSidePanel: null,
  patients: [],
  inVisitRoom: false,
  currentPatientInfo: {},
  visitInfo: {},
  visitICDCodes: [],
  visitNotesInfo: {},
  isRequestingRoomInfo: false,
  providerInitiatingVisit: false,
  isRequestingPermissions: false,
  permissionsGranted: false,
  permissionsDenied: false,
  isCallEndedSuccess: false,
  providerProfile: {},
  showVisitWave: false,
  isAllergyDeletedSuccess: false,
  isAllergyAddedSuccess: false,
  allergyNameError: '',
  allergySeverityError: '',
  isAllergiesRequestFinished: false,
  allergyError: '',
  prescriptionsListByVisitId: {},
  patientTreatLink: '',
  isVisitNotesSavedSuccess: false,
  isPatientInstructionSavedSuccess: false,
  isLogoutPressed: false,
  icdCodesSearchResults: [],
  isWaitingRoomPatientsLoading: false,
  patientId: '',
  visitInfoLoading: false,
  forceUpdateWaitingRoom: false,
  retrievingTreatUrl: false,
  updatingAllergies: false,
  updatingICDCodes: false,
  updatingNotes: false,
  updatingInstructions: false,
  loadingICDResults: false,
  errorCode: false,
  phoneError: '',
  orderData,
  orderPaymentData: [
    {
      name: 'order 1 - 0.25',
      cost: '200',
      address: '394 E Right St, San Dimas, CA 93049',
    },
    {
      name: 'order 2 - 0.25',
      cost: '500',
      address: '394 E Right St, San Dimas, CA 93049',
    },
  ],
  dailyDialOutData: { callerId: '' },
  ...initialVisitRoomState,
}

export default function waitingRoomReducer(state = initialState, action = {}) {
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  switch (action.type) {
    case GET_PATIENTS:
      appInsights.trackEvent({
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        name: action.type,
        properties: { ...state.providerProfile, ...action },
      })
      return {
        ...state,
        loading: true,
        isWaitingRoomPatientsLoading: true,
        forceUpdateWaitingRoom: false,
      }
    case GET_PATIENTS_BACKGROUND:
      return {
        ...state,
        forceUpdateWaitingRoom: false,
      }
    case BACK_IN_QUEUE:
    case START_VISIT_VIDEO_CALL:
    case COMPLETE_VISIT_CALL:
    case GET_PROVIDER:
    case GET_PHONE_CALL_TOKEN:
    case GET_VISIT_PATIENT_CHART:
    case END_VISIT:
      appInsights.trackEvent({
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        name: action.type,
        properties: { ...state.providerProfile, ...action },
      })
      return {
        ...state,
        loading: true,
      }
    case GET_PATIENT_PRESCRIPTIONS:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        loading: !action.payload.isSilent,
      }
    case ADD_PATIENT_ALLERGY:
    case DELETE_PATIENT_ALLERGY:
    case SET_VISIT_PATIENT_HAS_NO_ALLERGIES:
    case SET_VISIT_PATIENT_HAS_ALLERGIES:
      return {
        ...state,
        updatingAllergies: true,
        allergySeverityError: '',
        allergyNameError: '',
      }
    case GET_PATIENT_TREAT_URL:
      return {
        ...state,
        retrievingTreatUrl: true,
      }
    case SEARCH_FOR_ICD_CODES:
      return {
        ...state,
        loadingICDResults: true,
      }
    case UPDATE_ICD_CODES:
      return {
        ...state,
        updatingICDCodes: true,
      }
    case GET_VISIT_INFO:
      return {
        ...state,
        visitInfoLoading: true,
      }
    case SAVE_VISIT_NOTES:
    case DELETE_VISIT_NOTES:
      return {
        ...state,
        updatingNotes: true,
        notesChangeLoading: true,
      }
    case SAVE_VISIT_PATIENT_INSTRUCTIONS:
    case DELETE_VISIT_PATIENT_INSTRUCTIONS:
      return {
        ...state,
        updatingInstructions: true,
        notesChangeLoading: true,
      }
    case GET_PATIENTS_CHART_SUCCESS:
    case GET_PATIENT_DRUG_SCREEN_INFO_SUCCESS:
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      const updateCurrentPatient = state.currentPatientInfo.PatientId === action.payload.PatientId
      const updatedPatients = JSON.parse(JSON.stringify(state.patients))
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      updatedPatients.forEach((patient, index) => {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        if (patient.Patient.PatientId === action.extraData.patientId) {
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          patient.Patient.DrugScreen = action.payload.DrugScreen
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          patient.Patient.IdentityVerification = action.payload.IdentityVerification

          // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
          updatedPatients[index] = patient
        }
      })
      return {
        ...state,
        patients: updatedPatients,
        currentPatientInfo:
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          updateCurrentPatient ? { ...state.currentPatientInfo, ...action.payload } : state.currentPatientInfo,
      }
    case GET_PATIENT_PRESCRIPTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        prescriptionsListByVisitId: {
          ...state.prescriptionsListByVisitId,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.extraData.visitId]: action.payload,
        },
      }
    case SET_PATIENT_TREAT_URL:
      return {
        ...state,
        loading: false,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        patientTreatLink: action.payload,
      }
    case GET_PATIENT_TREAT_URL_SUCCESS:
      return {
        ...state,
        retrievingTreatUrl: false,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        patientTreatLink: action.payload?.ProfileUrl,
      }
    case SAVE_VISIT_PATIENT_INSTRUCTIONS_SUCCESS:
    case DELETE_VISIT_PATIENT_INSTRUCTIONS_SUCCESS:
      return {
        ...state,
        updatingInstructions: false,
        notesChangeLoading: false,
        isPatientInstructionSavedSuccess: true,
        visitNotesInfo: {
          ...state.visitNotesInfo,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.extraData.visitId]: {
            // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
            ...state.visitNotesInfo?.[action.extraData.visitId],
            PatientInstructions: {
              // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
              ...state.visitNotesInfo?.[action.extraData.visitId]?.PatientInstructions,
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              Message: action.extraData.PatientInstructions,
            },
          },
        },
      }
    case SAVE_VISIT_NOTES_SUCCESS:
    case DELETE_VISIT_NOTES_SUCCESS:
      return {
        ...state,
        updatingNotes: false,
        notesChangeLoading: false,
        isVisitNotesSavedSuccess: true,
        visitNotesInfo: {
          ...state.visitNotesInfo,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.extraData.visitId]: {
            // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
            ...state.visitNotesInfo?.[action.extraData.visitId],
            Notes: {
              // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
              ...state.visitNotesInfo?.[action.extraData.visitId]?.Notes,
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              Message: action.extraData.Notes,
            },
          },
        },
      }
    case ADD_VISIT_ORDER:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        orderPaymentData: [...state.orderPaymentData, action.payload],
      }
    case END_VISIT_SUCCESS:
      return {
        ...state,
        loading: false,
        isVisitEndedSuccess: true,
        icdCodesSearchResults: [],
      }
    case SEARCH_FOR_ICD_CODES_SUCCESS:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        icdCodesSearchResults: { results: action.payload, searchId: action.extraData.searchId },
        loadingICDResults: false,
      }
    case CHART_UPDATE_ICD_CODES_SUCCESS:
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (action.extraData.visitId !== state.activeVisitId && state.activeVisitId) return { ...state }
      return {
        ...state,
        loading: false,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        visitICDCodes: action.extraData.codes,
      }
    case UPDATE_ICD_CODES_SUCCESS:
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (action.extraData.visitId !== state.activeVisitId && state.activeVisitId) return { ...state }
      return {
        ...state,
        updatingICDCodes: false,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        visitICDCodes: action.extraData.codes,
      }
    case CHANGE_IS_VISIT_ENDED:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        isVisitEndedSuccess: action.payload,
      }
    case SET_LOADING:
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (!action.payload) {
        return {
          ...state,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          forceLoading: action.payload,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          loading: action.payload,
        }
      }
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        forceLoading: action.payload,
      }
    case SET_IS_VISIT_NOTES_SAVED_SUCCESS:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        isVisitNotesSavedSuccess: action.payload,
      }
    case SET_IS_PATIENT_INSTRUCTIONS_SAVED_SUCCESS:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        isPatientInstructionSavedSuccess: action.payload,
      }
    case GET_PATIENTS_SUCCESS:
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      const activeVisit = action.payload.find((visit) => visit.VisitId === state.activeVisitId)
      if (activeVisit?.IsPatientAvailable) {
        return {
          ...state,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          patients: action.payload,
          loading: false,
          isWaitingRoomPatientsLoading: false,
          showVisitWave: true,
          isCallEndedSuccess: false,
          forceUpdateWaitingRoom: false,
        }
      }
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        patients: action.payload,
        isWaitingRoomPatientsLoading: false,
        loading: false,
        isCallEndedSuccess: false,
        forceUpdateWaitingRoom: false,
      }
    case SET_VISIT_PATIENT_HAS_ALLERGIES_SUCCESS:
    case SET_PATIENT_HAS_ALLERGIES_SUCCESS:
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (action.extraData.patientId === state.currentPatientInfo.PatientId) {
        return {
          ...state,
          updatingAllergies: false,
          currentPatientInfo: {
            ...state.currentPatientInfo,
            AllergyCollection: {
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              ...state.currentPatientInfo.AllergyCollection,
              HasNoAllergyConfirmation: false,
            },
          },
        }
      }
      return {
        ...state,
      }
    case SET_VISIT_PATIENT_HAS_NO_ALLERGIES_SUCCESS:
    case SET_PATIENT_HAS_NO_ALLERGIES_SUCCESS:
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (action.extraData.patientId === state.currentPatientInfo.PatientId) {
        return {
          ...state,
          updatingAllergies: false,
          currentPatientInfo: {
            ...state.currentPatientInfo,
            AllergyCollection: { Allergies: [], HasNoAllergyConfirmation: true },
          },
        }
      }
      return {
        ...state,
      }
    case GET_VISIT_PATIENT_CHART_SUCCESS:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        currentPatientInfo: { ...state.currentPatientInfo, ...action.payload },
        loading: false,
      }
    case GET_PROVIDER_SUCCESS:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        providerProfile: action.payload,
        loading: false,
      }
    case EDIT_PROVIDER_PROFILE_INFO_SUCCESS: {
      const key = getGetProfileQueryKey()
      // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
      client.setQueryData(key, (oldData) => ({ ...oldData, TimeZone: action.payload.data.TimeZone }))
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        providerProfile: action.payload.data,
        loading: false,
      }
    }
    case CHECK_PHONE:
      appInsights.trackEvent({
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        name: action.type,
        properties: { ...state.providerProfile, ...action },
      })
      return {
        ...state,
        loading: true,
      }
    case CHECK_PHONE_SUCCESS:
      return {
        ...state,
        loading: false,
        isPhoneCorrect: true,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        phoneNumber: action.extraData,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        phoneVerifyOptions: action.payload?.VerificationChannels,
        errorCode: false,
        phoneError: '',
      }

    case EDIT_PROVIDER_PROFILE_IMAGE_SUCCESS:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        providerProfile: { ...state.providerProfile, ImageUrl: action?.payload?.data?.ImageUrl },
        loading: false,
      }
    case COMPLETE_VISIT_CALL_SUCCESS:
    case SUCCESS_VISIT:
      return {
        ...state,
        isCallEndedSuccess: true,
        loading: false,
        isVisitEndedSuccess: false,
        ...initialVisitRoomState,
        // `inVisitRoom` lives on `initialState`, not `initialVisitRoomState`, so the spread
        // above cannot clear it. It is otherwise only cleared by LEAVE_VISIT_ROOM /
        // SET_VISIT_ROOM, which are dispatched from VisitCallRoom — a component the
        // Dashboard flow never mounts. Left set, it keeps
        // `useInVisitKeepAlive` writing `lastUserAction` forever and suppresses the
        // idle logoff origin-wide. Clear it explicitly on every visit-completion path.
        inVisitRoom: false,
      }
    case GET_PHONE_CALL_TOKEN_SUCCESS:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        phoneCallToken: action.payload.AccessToken,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        profileImage: action.extraData.profileImage,
        isCallEndedSuccess: false,
        inVisitRoom: true,
        loading: false,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        activeVisitId: action.extraData.VisitId,
        showVisitWave: false,
        videoCallToken: '',
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        dailyDialOutData: { callerId: action.payload.CallerId },
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        roomUrl: action.payload.RoomUrl,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        platform: action.payload.Platform,
        providerInitiatingVisit: false,
        currentPatientInfo:
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          action.extraData.isReconnecting ? { ...state.currentPatientInfo } : { PatientId: action.extraData.patientId },
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        icdCodesSearchResults: action.extraData.isReconnecting ? state.icdCodesSearchResults : [],
      }
    case START_VISIT_VIDEO_CALL_SUCCESS:
      return {
        ...state,
        isCallEndedSuccess: false,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        patientVideoCallName: action.extraData.patientName,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        visitCallId: action.extraData.VisitId,
        isRoomSuccessCreated: true,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        roomName: action.payload.RoomName,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        videoCallToken: action.payload.AccessToken,
        phoneCallToken: '',
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        platform: action.payload.Platform,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        roomUrl: action.payload.RoomUrl,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        profileImage: action.extraData.profileImage,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        videoCallTimeout: action.payload.ExpireDateTimeUtc,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        videoCallTimeoutReceivedAtMs: action.extraData.receivedAtMs,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        visitVideoCallId: action.payload.VisitVideoCallId,
        inVisitRoom: true,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        activeVisitId: action.extraData.VisitId,
        showVisitWave: false,
        isRequestingRoomInfo: false, // Clear requesting state when room info received
        providerInitiatingVisit: false, // Visit has started
        currentPatientInfo:
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          action.extraData.isReconnecting ? { ...state.currentPatientInfo } : { PatientId: action.extraData.patientId },
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        icdCodesSearchResults: action.extraData.isReconnecting ? state.icdCodesSearchResults : [],
      }

    case START_INPERSON_VISIT: {
      return {
        ...state,
        loading: true,
      }
    }
    case START_INPERSON_VISIT_SUCCESS:
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      const visit = action.extraData
      const { VisitId, Patient } = visit
      const { FirstName, LastName, ImageUrl, PatientId } = Patient

      const patientName = `${FirstName} ${LastName}`

      return {
        ...state,
        loading: false,
        isCallEndedSuccess: false,
        patientVideoCallName: patientName,
        isRoomSuccessCreated: true,
        profileImage: ImageUrl,
        inVisitRoom: true,
        activeVisitId: VisitId,
        showVisitWave: false,
        providerInitiatingVisit: false, // Visit has started
        currentPatientInfo: { PatientId },
        icdCodesSearchResults: [],
      }
    case GET_VISIT_INFO_SUCCESS:
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (!action.payload.Notes) {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        return { ...state, visitInfo: { ...state.visitInfo, Price: action.payload.Price } }
      }

      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        visitInfo: action.payload,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        visitICDCodes: action.payload.IcdCodes,
        visitInfoLoading: false,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        patientId: action.payload.PatientId,
        visitNotesInfo: {
          ...state.visitNotesInfo,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.extraData.visitId]: {
            // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
            ...state.visitNotesInfo?.[action.extraData.visitId],
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            Notes: action.payload.Notes.find((noteItem) => !noteItem.IsAddendum),
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            PatientInstructions: action.payload.PatientInstructions.find(
              // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
              (patientInstructionItem) => !patientInstructionItem.IsAddendum,
            ),
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            SpentTimeMinutes: action.payload.SpentTimeMinutes,
          },
        },
      }
    case GET_PATIENT_CREDIT_CARDS_SUCCESS:
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (state.currentPatientInfo.PatientId === action.extraData.patientId) {
        return {
          ...state,
          loading: false,
          currentPatientInfo: {
            ...state.currentPatientInfo,
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            creditCards: action.payload,
          },
        }
      }
      return { ...state }
    case ADD_PATIENT_ALLERGY_SUCCESS:
    case ADD_PATIENT_ALLERGY_SUCCESS_CHARTS:
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (state.currentPatientInfo.PatientId === action.extraData.patientId) {
        return {
          ...state,
          currentPatientInfo: {
            ...state.currentPatientInfo,
            AllergyCollection: {
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              ...state.currentPatientInfo.AllergyCollection,
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              Allergies: [...(state.currentPatientInfo.AllergyCollection?.Allergies ?? []), action.payload],
              HasNoAllergyConfirmation: false,
            },
          },
          isAllergyAddedSuccess: true,
          isAllergiesRequestFinished: true,

          updatingAllergies: false,
        }
      }
      return {
        ...state,
      }
    case DELETE_PATIENT_ALLERGY_FROM_STORAGE: {
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (state.currentPatientInfo.PatientId === action.extraData.patientId) {
        return {
          ...state,
          currentPatientInfo: {
            ...state.currentPatientInfo,
            AllergyCollection: {
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              ...state.currentPatientInfo.AllergyCollection,
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              Allergies: state.currentPatientInfo?.AllergyCollection?.Allergies?.filter(
                // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
                (allergy) => allergy.AllergyId !== action.extraData.allergyId,
              ),
            },
          },
        }
      }
      return {
        ...state,
      }
    }
    case DELETE_PATIENT_ALLERGY_SUCCESS:
    case DELETE_PATIENT_ALLERGY_SUCCESS_CHARTS:
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (state.currentPatientInfo.PatientId === action.extraData.patientId) {
        return {
          ...state,
          loading: false,
          isAllergyDeletedSuccess: true,
          updatingAllergies: false,
          currentPatientInfo: {
            ...state.currentPatientInfo,
            AllergyCollection: {
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              ...state.currentPatientInfo.AllergyCollection,
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              Allergies: state.currentPatientInfo?.AllergyCollection?.Allergies?.filter(
                // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
                (allergy) => allergy.AllergyId !== action.extraData.allergyId,
              ),
            },
          },
        }
      }
      return { ...state }
    case SET_FORCE_UPDATE_WAITING_ROOM:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        forceUpdateWaitingRoom: action.payload,
      }
    case SET_IS_ROOM_SUCCESS_CREATED:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        isRoomSuccessCreated: action.payload,
      }
    case SET_VISIT_INFO:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        visitInfo: action.payload,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        ...(action.payload === null && initialVisitRoomState),
      }
    case RESET_IS_ADDED_ALLERGY_STATUS:
      return {
        ...state,
        loading: false,
        isAllergyAddedSuccess: false,
        isAllergiesRequestFinished: false,
      }
    case RESET_IS_DELETED_ALLERGY_STATUS:
      return {
        ...state,
        loading: false,
        isAllergyDeletedSuccess: false,
      }
    case CHANGE_CURRENT_PATIENT_ACCOUNT_INFO:
      if (
        Object.keys(state.currentPatientInfo)?.length &&
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        state.currentPatientInfo?.PatientId === action.payload.patientId
      ) {
        return {
          ...state,
          currentPatientInfo: {
            ...state.currentPatientInfo,
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            PreferredName: action.payload?.accountInfo?.PreferredName,
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            BirthDate: action.payload?.accountInfo?.BirthDate,
          },
        }
      }
      return state
    case CLEAR_PHONE_TOKEN:
      return {
        ...state,
        phoneCallToken: '',
      }
    case CLEAR_STALE_CALL_TOKENS:
      return {
        ...state,
        phoneCallToken: '',
        videoCallToken: '',
        roomUrl: '',
        platform: '',
        // Cleared with the tokens they belong to. Leaving them behind left a live ring timeout
        // pointing at a room that no longer exists (QMD-4640).
        videoCallTimeout: null,
        videoCallTimeoutReceivedAtMs: null,
      }
    case SET_NEW_PROVIDER_PROFILE_SETTINGS:
      return {
        ...state,
        providerProfile: {
          ...state.providerProfile,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          Settings: action.payload,
        },
      }

    case RESET_WAITING_ROOM_PAGE:
      return {
        ...initialState,
      }
    case CHECK_PHONE_ERROR: {
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      const { Data, ErrorCode, number } = action.payload
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      console.log('action.payload', action.payload)

      let errorMessage = ''

      if (ErrorCode === 'ThirdPartyError') {
        // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
        const { ErrorCode: subErrorCode, ErrorMessage } = Data
        console.log('ThirdPartyError subErrorCode:', subErrorCode)

        if (subErrorCode === 'PhoneNumberNotValid') {
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          errorMessage = getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, 'Phone number')
        } else {
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          errorMessage = getUserFriendlyErrorMessage(subErrorCode, null, 'Phone number')
        }
      } else if (ErrorCode === 'PhoneNumberNotValid') {
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        errorMessage = getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, 'Phone number')
      } else {
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        errorMessage = getUserFriendlyErrorMessage(ErrorCode, null, 'Phone number')
      }

      return {
        ...state,
        isPhoneCorrect: false,
        checkedPhoneNumber: number,
        phoneError: errorMessage,
        loading: false,
      }
    }
    case SET_PHONE_ERROR:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        phoneError: action.payload,
      }
    case CLEAR_PHONE_ERROR:
      return {
        ...state,
        phoneError: '',
      }

    case GET_VISIT_INFO_ERROR:
    case GET_PATIENTS_ERROR:
    case GET_PROVIDER_ERROR:
    case SET_ERROR:
    case START_VISIT_VIDEO_CALL_ERROR:
    case START_INPERSON_VISIT_ERROR:
    case COMPLETE_VISIT_CALL_ERROR:
    case GET_PHONE_CALL_TOKEN_ERROR:
    case GET_VISIT_PATIENT_CHART_ERROR:
    case SAVE_VISIT_PATIENT_INSTRUCTIONS_ERROR:
    case GET_PATIENT_PRESCRIPTIONS_ERROR:
    case GET_PATIENT_TREAT_URL_ERROR:
    case SAVE_VISIT_NOTES_ERROR:
    case BACK_IN_QUEUE_ERROR:
    case ADD_PATIENT_ALLERGY_ERROR:
    case DELETE_PATIENT_ALLERGY_ERROR:
    case END_VISIT_ERROR:
    case DELETE_VISIT_NOTES_ERROR:
    case DELETE_VISIT_PATIENT_INSTRUCTIONS_ERROR:
    case SEARCH_FOR_ICD_CODES_ERROR:
    case UPDATE_ICD_CODES_ERROR:
    case SET_VISIT_PATIENT_HAS_ALLERGIES_ERROR:
    case SET_VISIT_PATIENT_HAS_NO_ALLERGIES_ERROR:
      let message = ''
      let allergyNameErrorMessage = ''
      let allergySeverityErrorMessage = ''
      let defaultServerErrorMessage = ''
      let isAllergyAlreadyDeleted = false
      let isNotResetLoading = false

      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (action.payload.UserFriendlyErrorCode || action.payload.UserFriendlyErrorCode === '') {
        message =
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          action.payload.UserFriendlyErrorCode ?
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            getUserFriendlyErrorMessage(action.payload.UserFriendlyErrorCode, null, action.payload.extra)
          : ''
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        defaultServerErrorMessage = action.payload.UserFriendlyErrorCode ? action.payload : ''
      } else {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        switch (action.payload.ErrorCode) {
          case THIRD_PARTY_ERROR:
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            const { ErrorCode, ErrorMessage } = action.payload.Data
            message = `${ErrorCode} - ${ErrorMessage}`
            break
          case ALLERGY_NAME_NOT_UNIQUE_ERROR:
            message = getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS)
            allergyNameErrorMessage = getUserFriendlyErrorMessage(errorCodes.ALLERGY_NAME_NOT_UNIQUE)
            return {
              ...state,
              providerInitiatingVisit: false,
              error: message,
              allergyNameError: allergyNameErrorMessage,
              loading: isNotResetLoading,
              isAllergyAddedSuccess: true,
              isAllergiesRequestFinished: isNotResetLoading,
              updatingAllergies: false,
            }
          case ALLERGY_NOT_FOUND_ERROR:
            isAllergyAlreadyDeleted = true
            return {
              ...state,
              providerInitiatingVisit: false,
              error: message,
              isWaitingRoomPatientsLoading: false,
              allergyNameError: allergyNameErrorMessage,
              loading: isNotResetLoading,
              isAllergyDeletedSuccess: true,
              isAllergiesRequestFinished: isNotResetLoading,
              updatingAllergies: false,
            }
          case ALLERGY_NAME_NOT_VALID_ERROR:
            message = getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS)
            // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
            allergyNameErrorMessage = getUserFriendlyErrorMessage(errorCodes.NOT_VALID_VALUE, null, 'Allergy name')

            return {
              ...state,
              providerInitiatingVisit: false,
              error: message,
              isWaitingRoomPatientsLoading: false,
              allergyNameError: allergyNameErrorMessage,
              loading: isNotResetLoading,
              isAllergyAddedSuccess: message,
              isAllergyDeletedSuccess: isAllergyAlreadyDeleted || message,
              isAllergiesRequestFinished: isNotResetLoading,
              updatingAllergies: false,
            }
          case apiErrorCodes.PATIENT_NOT_FOUND:
            return {
              ...state,
              providerInitiatingVisit: false,
              updatingAllergies: false,
              loading: false,
              // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
              error: getUserFriendlyErrorMessage(errorCodes.NOT_FOUND, null, 'Patient'),
            }
          case apiErrorCodes.ICD_CODE_COUNT_NOT_VALID:
            return {
              ...state,
              providerInitiatingVisit: false,
              // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
              error: getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, text.ICD_CODE),
              loading: false,
            }
          case ALLERGY_SEVERITY_NOT_VALID_ERROR:
            isNotResetLoading = true
            message = getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS)
            allergySeverityErrorMessage = getUserFriendlyErrorMessage(
              errorCodes.NOT_VALID_VALUE,
              // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
              null,
              'Allergy Severity',
            )
            return {
              ...state,
              providerInitiatingVisit: false,
              error: message,
              allergySeverityError: allergySeverityErrorMessage,
              loading: isNotResetLoading,
              isWaitingRoomPatientsLoading: false,
              isAllergyAddedSuccess: message,
              isAllergyDeletedSuccess: isAllergyAlreadyDeleted || message,
              isAllergiesRequestFinished: isNotResetLoading,
              updatingAllergies: false,
            }
          case TREAT_COMMUNICATION_ERROR:
            message = getUserFriendlyErrorMessage(errorCodes.TREAT_ERROR)
            return {
              ...state,
              providerInitiatingVisit: false,
              error: message,
              retrievingTreatUrl: false,
            }
          case VISIT_NOT_FOUND_ERROR:
            return {
              ...state,
              providerInitiatingVisit: false,
              // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
              error: getUserFriendlyErrorMessage(errorCodes.ITEM_DOES_NOT_EXIST, null, 'visit'),
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              selectedVisitForSidePanel: action.extraData?.isReconnecting ? state.selectedVisitForSidePanel : null,
              loading: false,
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              retrievingTreatUrl: action.type === GET_PATIENT_TREAT_URL_ERROR ? false : state.retrievingTreatUrl,
              updatingAllergies:
                // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                action.type === ADD_PATIENT_ALLERGY_ERROR || action.type === DELETE_PATIENT_ALLERGY_ERROR ?
                  false
                : state.updatingAllergies,
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              updatingICDCodes: action.type === UPDATE_ICD_CODES_ERROR ? false : state.updatingICDCodes,
              updatingNotes:
                // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                action.type === DELETE_VISIT_NOTES_ERROR || action.type === SAVE_VISIT_NOTES_ERROR ?
                  false
                : state.updatingNotes,
              updatingInstructions:
                (
                  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                  action.type === DELETE_VISIT_PATIENT_INSTRUCTIONS_ERROR ||
                  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                  action.type === SAVE_VISIT_PATIENT_INSTRUCTIONS_ERROR
                ) ?
                  false
                : state.updatingInstructions,
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              loadingICDResults: action.type === SEARCH_FOR_ICD_CODES_ERROR ? false : state.loadingICDResults,
            }
          case visitNotStarted:
            return {
              ...state,
              providerInitiatingVisit: false,
              isCallEndedSuccess: true,
              phoneCallToken: '',
              loading: false,
              inVisitRoom: false,
              visitVideoCallId: '',
              selectedVisitForSidePanel: null,
              activeVisitId: '',
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              retrievingTreatUrl: action.type === GET_PATIENT_TREAT_URL_ERROR ? false : state.retrievingTreatUrl,
              updatingAllergies:
                // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                action.type === ADD_PATIENT_ALLERGY_ERROR || action.type === DELETE_PATIENT_ALLERGY_ERROR ?
                  false
                : state.updatingAllergies,
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              updatingICDCodes: action.type === UPDATE_ICD_CODES_ERROR ? false : state.updatingICDCodes,
              updatingNotes:
                // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                action.type === DELETE_VISIT_NOTES_ERROR || action.type === SAVE_VISIT_NOTES_ERROR ?
                  false
                : state.updatingNotes,
              updatingInstructions:
                (
                  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                  action.type === DELETE_VISIT_PATIENT_INSTRUCTIONS_ERROR ||
                  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                  action.type === SAVE_VISIT_PATIENT_INSTRUCTIONS_ERROR
                ) ?
                  false
                : state.updatingInstructions,
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              loadingICDResults: action.type === SEARCH_FOR_ICD_CODES_ERROR ? false : state.loadingICDResults,
            }
          case VISIT_CALL_FORBIDDEN_ERROR:
            return {
              ...state,
              providerInitiatingVisit: false,
              // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
              error: getUserFriendlyErrorMessage(errorCodes.INVALID_VISIT_METHOD, null),
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              selectedVisitForSidePanel: action.extraData?.isReconnecting ? state.selectedVisitForSidePanel : null,
              loading: false,
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              retrievingTreatUrl: action.type === GET_PATIENT_TREAT_URL_ERROR ? false : state.retrievingTreatUrl,
              updatingAllergies:
                // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                action.type === ADD_PATIENT_ALLERGY_ERROR || action.type === DELETE_PATIENT_ALLERGY_ERROR ?
                  false
                : state.updatingAllergies,
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              updatingICDCodes: action.type === UPDATE_ICD_CODES_ERROR ? false : state.updatingICDCodes,
              updatingNotes:
                // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                action.type === DELETE_VISIT_NOTES_ERROR || action.type === SAVE_VISIT_NOTES_ERROR ?
                  false
                : state.updatingNotes,
              updatingInstructions:
                (
                  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                  action.type === DELETE_VISIT_PATIENT_INSTRUCTIONS_ERROR ||
                  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                  action.type === SAVE_VISIT_PATIENT_INSTRUCTIONS_ERROR
                ) ?
                  false
                : state.updatingInstructions,
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              loadingICDResults: action.type === SEARCH_FOR_ICD_CODES_ERROR ? false : state.loadingICDResults,
            }
          case apiErrorCodes.ICD_CODE_NOT_FOUND:
            return {
              ...state,
              providerInitiatingVisit: false,
              // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
              error: getUserFriendlyErrorMessage(errorCodes.ITEM_DOES_NOT_EXIST, null, text.ICD_CODE),
              loading: false,
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              updatingICDCodes: action.type === UPDATE_ICD_CODES_ERROR ? false : state.updatingICDCodes,
            }
          case FORBIDDEN_ERROR:
            return {
              ...state,
              providerInitiatingVisit: false,
              error: getUserFriendlyErrorMessage(errorCodes.VISIT_HAS_COMPLETED),
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              selectedVisitForSidePanel: action.extraData?.isReconnecting ? state.selectedVisitForSidePanel : null,
              loading: false,
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              retrievingTreatUrl: action.type === GET_PATIENT_TREAT_URL_ERROR ? false : state.retrievingTreatUrl,
              updatingAllergies:
                // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                action.type === ADD_PATIENT_ALLERGY_ERROR || action.type === DELETE_PATIENT_ALLERGY_ERROR ?
                  false
                : state.updatingAllergies,
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              updatingICDCodes: action.type === UPDATE_ICD_CODES_ERROR ? false : state.updatingICDCodes,
              updatingNotes:
                // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                action.type === DELETE_VISIT_NOTES_ERROR || action.type === SAVE_VISIT_NOTES_ERROR ?
                  false
                : state.updatingNotes,
              updatingInstructions:
                (
                  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                  action.type === DELETE_VISIT_PATIENT_INSTRUCTIONS_ERROR ||
                  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                  action.type === SAVE_VISIT_PATIENT_INSTRUCTIONS_ERROR
                ) ?
                  false
                : state.updatingInstructions,
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              loadingICDResults: action.type === SEARCH_FOR_ICD_CODES_ERROR ? false : state.loadingICDResults,
            }
          case INTERNAL_SERVER_ERROR:
            return {
              ...state,
              providerInitiatingVisit: false,
              isWaitingRoomPatientsLoading: false,
              error: getUserFriendlyErrorMessage(errorCodes.DEFAULT),
              loading: false,
              notesChangeLoading: false,
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              retrievingTreatUrl: action.type === GET_PATIENT_TREAT_URL_ERROR ? false : state.retrievingTreatUrl,
              updatingAllergies:
                // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                action.type === ADD_PATIENT_ALLERGY_ERROR || action.type === DELETE_PATIENT_ALLERGY_ERROR ?
                  false
                : state.updatingAllergies,
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              updatingICDCodes: action.type === UPDATE_ICD_CODES_ERROR ? false : state.updatingICDCodes,
              updatingNotes:
                // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                action.type === DELETE_VISIT_NOTES_ERROR || action.type === SAVE_VISIT_NOTES_ERROR ?
                  false
                : state.updatingNotes,
              updatingInstructions:
                (
                  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                  action.type === DELETE_VISIT_PATIENT_INSTRUCTIONS_ERROR ||
                  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                  action.type === SAVE_VISIT_PATIENT_INSTRUCTIONS_ERROR
                ) ?
                  false
                : state.updatingInstructions,
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              loadingICDResults: action.type === SEARCH_FOR_ICD_CODES_ERROR ? false : state.loadingICDResults,
            }
          default:
            appInsights.trackEvent({
              name: 'No Error Case Checked',
              properties: { ...state.providerProfile, ...action },
            })
            break
        }
      }
      return {
        ...state,
        providerInitiatingVisit: false,
        error: message,
        allergyNameError: allergyNameErrorMessage,
        allergySeverityError: allergySeverityErrorMessage,
        defaultServerErrorMessage,
        loading: false,
        notesChangeLoading: false,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        isRequestingRoomInfo: action.type === START_VISIT_VIDEO_CALL_ERROR ? false : state.isRequestingRoomInfo,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        retrievingTreatUrl: action.type === GET_PATIENT_TREAT_URL_ERROR ? false : state.retrievingTreatUrl,
        updatingAllergies:
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          action.type === ADD_PATIENT_ALLERGY_ERROR || action.type === DELETE_PATIENT_ALLERGY_ERROR ?
            false
          : state.updatingAllergies,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        updatingICDCodes: action.type === UPDATE_ICD_CODES_ERROR ? false : state.updatingICDCodes,
        updatingNotes:
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          action.type === DELETE_VISIT_NOTES_ERROR || action.type === SAVE_VISIT_NOTES_ERROR ?
            false
          : state.updatingNotes,
        updatingInstructions:
          (
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            action.type === DELETE_VISIT_PATIENT_INSTRUCTIONS_ERROR ||
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            action.type === SAVE_VISIT_PATIENT_INSTRUCTIONS_ERROR
          ) ?
            false
          : state.updatingInstructions,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        loadingICDResults: action.type === SEARCH_FOR_ICD_CODES_ERROR ? false : state.loadingICDResults,
      }
    case SET_ERROR_ALLERGY:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        allergyError: action.payload,
      }
    case LEAVE_VISIT_ROOM:
      return {
        ...state,
        inVisitRoom: false,
      }
    case SET_VISIT_ROOM:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        inVisitRoom: action.payload,
      }
    case LOGOUT:
      return {
        ...initialState,
        isLogoutPressed: true,
      }
    case SET_IS_VIDEO_DECLINED:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        isVideoDeclined: action.payload,
      }
    case SET_IS_REQUESTING_PERMISSIONS:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        isRequestingPermissions: action.payload,
      }
    case SET_PERMISSIONS_GRANTED:
      return {
        ...state,
        isRequestingPermissions: false,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        permissionsGranted: action.payload,
      }
    case SET_PERMISSIONS_DENIED:
      return {
        ...state,
        isRequestingPermissions: false,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        permissionsDenied: action.payload,
      }
    case SET_IS_REQUESTING_ROOM_INFO:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        isRequestingRoomInfo: action.payload,
      }
    case SET_PROVIDER_INITIATING_VISIT:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        providerInitiatingVisit: action.payload,
        // only reset room state if provider is initiating visit. if we are just making sure the flag is false, we may
        // not actually be intending to reset the room state.
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        ...(action.payload ? initialVisitRoomState : {}),
      }
    default:
      return state
  }
}
